





import { Component, Prop, Vue } from 'vue-property-decorator';
import imgs from '@/util/imgs.ts';

@Component
export default class Gallery extends Vue {
  @Prop({ default: imgs.gallery_chanpin1 })
  private pic!: any[];
}
